<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcClientRegistrationForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    computed: {
        // @deprecated v1 only
        isTaxCountryLithuania() {
            return this.model && this.model.$.tax_country && this.model.$.tax_country.trim().toLowerCase() === 'lietuva';
        },

        canSubmit() {
            if (!this.model) {
                return false;
            }

            return true;
        },
    },

    watch: {
        isTaxCountryLithuania(value) {
            if (!this.model) {
                return;
            }

            if (value) {
                this.model.$.tax_country = 'Lietuva';
            }
        },
    },

    methods: {
        // @deprecated v1 only
        setTaxCountryLithuania() {
            this.model.$.tax_country = 'Lietuva';
        },

        // @deprecated v1 only
        clearTaxCountry() {
            this.model.$.tax_country = '';
        },

        addTaxCountry() {
            this.model.$.tax_countries.push({
                country_id: null,
                payer_code: '',
            });
        },

        removeTaxCountry(taxCountry) {
            this.model.$.tax_countries = this.model.$.tax_countries.filter(s => s !== taxCountry);
        },

        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', this.model.data);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },
    },
};
</script>
